import {
    standardActionErrorMsg, standardActionSuccessMsg, StandardActionToastMessages
} from '~commonInfra/contentActions/ActionHelpers';
import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import { ChangeTagsActionHelperService } from '~content/services/ChangeTagsActionHelper';
import { Formatters, Messages } from '~src/codegen/Localize';
import { WorkbookContentType } from '~src/spacesPlatform/models/ContentTypes';
import { L10n } from '~src/ts/L10n/L10n';
import { Set } from '~src/ts/models/Set';
import { IChangeContentTagsResult } from '~src/ts/ServerApi/types/IChangeContentTagsAction';
import { ContentUrlForItem } from '~src/ts/services/ContentUrl';
import { IWorkbookBase } from '~src/workbook/models/IWorkbookInfo';
import { Workbooks } from '~src/workbook/resources/Workbooks';

export namespace ChangeWorkbooksTagsAction {

  export const notificationTranslationFns: StandardActionToastMessages = {
    success: standardActionSuccessMsg(Messages.changeTagsWorkbooksSuccess),
    error: standardActionErrorMsg(Messages.changeTagsWorkbooksError),
  };

  export function execute(itemSet: Set<IWorkbookBase>): Promise<IChangeContentTagsResult> {
    return ChangeTagsActionHelperService.createExecuteFn<IWorkbookBase>({
      changeTagsAction: (ids: string[], addTags: string[], removeTags: string[]) => Workbooks.changeTags(ids, addTags, removeTags),
      getDescription: (workbooks: Set<IWorkbookBase>) => getDescription(workbooks),
      notificationFns: notificationTranslationFns,
      errorDetailFn: (errorItem: IErrorItem<IWorkbookBase>) => changeTagsErrorDetail(errorItem)
    })(itemSet);
  }

  function getDescription(workbooks: Set<IWorkbookBase>) {
    return (workbooks.size() === 1)
      ? Messages.changeTagsWorkbookDescription({ NAME: L10n.elideIfLong(workbooks.first().name) })
      : Messages.changeTagsWorkbooksDescription({ COUNT_LOC: Formatters.formatCount(workbooks.size()) });
  }

  export function changeTagsErrorDetail(errorItem: IErrorItem<IWorkbookBase>): IErrorDetail {
    return {
      itemName: errorItem.item.name,
      itemUrl: ContentUrlForItem(errorItem.item, WorkbookContentType),
      errorMessage: ChangeTagsActionHelperService.errorMessageFor(errorItem)
    };
  }

}

export type ChangeWorkbooksTagsAction = typeof ChangeWorkbooksTagsAction;
